type TransitionOptions = {
  /**
   * Tailwind transition property class, e.g. "transition-all" or "transition-colors"
   */
  property?: string;
  /**
   * Tailwind duration value. Numbers will be converted to "duration-{value}" automatically.
   */
  duration?: number | string;
  /**
   * Tailwind easing function class such as "ease-out" or "ease-in-out"
   */
  easing?: string;
  /**
   * Tailwind delay value. Numbers will be converted to "delay-{value}" automatically.
   */
  delay?: number | string;
  /**
   * Any additional classes to append, e.g. "motion-reduce:transition-none"
   */
  additional?: string;
};

const DEFAULT_PROPERTY = "transition-all";
const DEFAULT_DURATION = 300;
const DEFAULT_EASING = "ease-out";

const formatTimedClass = (value: number | string | undefined, prefix: "duration" | "delay") => {
  if (value === undefined || value === "") {
    return "";
  }

  if (typeof value === "number") {
    return `${prefix}-${value}`;
  }

  // Allow passing full tailwind class names like "duration-500" or "duration-[350ms]"
  if (value.startsWith(`${prefix}-`)) {
    return value;
  }

  return `${prefix}-${value}`;
};

export const transition = ({
  property = DEFAULT_PROPERTY,
  duration = DEFAULT_DURATION,
  easing = DEFAULT_EASING,
  delay,
  additional,
}: TransitionOptions = {}) => {
  return [property, formatTimedClass(duration, "duration"), easing, formatTimedClass(delay, "delay"), additional]
    .filter(Boolean)
    .join(" ");
};

export const transitionDefaults = {
  property: DEFAULT_PROPERTY,
  duration: DEFAULT_DURATION,
  easing: DEFAULT_EASING,
} as const;
